export const styledBadge = {
    color: '#fff',
    borderRadius: '6px',
    fontSize: '11px',
    padding: '4px 7px',
    fontWeight: '700',
    lineHeight: '1',
};
